import React from 'react';
//import {useMutation, useNotify, Button } from 'react-admin';
import Button from '@material-ui/core/Button';
import { withStyles } from '@material-ui/core/styles';
import { Link } from 'react-router-dom';
import AddCircleIcon from '@material-ui/icons/AddCircle';


const styles = {
    icon: { paddingRight: '0.5em' },
    link: {
        display: 'inline-flex',
        alignItems: 'center',
    },
};

const LinkToCreate = ({ classes, ...props}) => {

    
    return <Button
        size="small"
        color="primary"
        component={Link}
        to={{
            pathname: '/absc/create',
            ssn: props.ssn
        }}
        className={classes.link}
       
    >
        <AddCircleIcon className={classes.icon} />Create
    </Button>
};


export default  withStyles(styles)(LinkToCreate);